// convert object to request params
export function objectToParams(obj: any): string {
  let params = [];
  for (const key in obj) {
    params.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
  }
  return params.join("&");
}

// extract request params from url link and convert it to an object
export function paramsToObject(url: string): Record<string, string> {
  const queryString = url.split("?")[1].split("#")[0];

  const query: Record<string, string> = {};
  queryString.split("&").forEach((param) => {
    const dict = param.split("=");
    query[dict[0]] = dict[1];
  });

  return query;
}

// // implementation by COP
// export function paramsToObject(url: string): any {
//   const params = url.split("?")[1];
//   if (!params) {
//     return {};
//   }
//   const pairs = params.split("&");
//   const result = {};
//   pairs.forEach((pair) => {
//     const [key, value] = pair.split("=");
//     result[key] = value;
//   });
//   return result;
// }

export const appendQueryStringPrefix = (
  queryKey: string,
  queryStringFilterPrefix: string
) =>
  `${
    !!queryStringFilterPrefix ? `${queryStringFilterPrefix}.` : ""
  }${queryKey}`;

// Helper function to transform query params and remove null properties
export function transformQueryParams(
  params: Record<string, any>,
  prefix = ""
): Record<string, string> {
  return Object.keys(params).reduce(
    (result: Record<string, string>, key: string) => {
      const value = params[key];
      const newKey = prefix ? `${prefix}.${key}` : key;

      if (value === null || value === undefined) {
        // Skip null or undefined values
        return result;
      }

      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (item !== null && item !== undefined) {
            const arrayKey = `${newKey}[${index}]`;
            if (typeof item === "object") {
              Object.assign(result, transformQueryParams({ [arrayKey]: item }));
            } else {
              result[arrayKey] = String(item);
            }
          }
        });
      } else if (typeof value === "object") {
        Object.assign(result, transformQueryParams(value, newKey));
      } else {
        result[newKey] = String(value);
      }

      return result;
    },
    {}
  );
}

// Helper function to transform query params
// export function transformQueryParams(
//   params: Record<string, any>,
//   prefix = ""
// ): Record<string, string> {
//   return Object.keys(params).reduce(
//     (result: Record<string, string>, key: string) => {
//       const value = params[key];
//       const newKey = prefix ? `${prefix}.${key}` : key;

//       if (Array.isArray(value)) {
//         value.forEach((item, index) => {
//           const arrayKey = `${newKey}[${index}]`;
//           if (typeof item === "object" && item !== null) {
//             Object.assign(result, transformQueryParams(item, arrayKey));
//           } else {
//             result[arrayKey] = String(item);
//           }
//         });
//       } else if (typeof value === "object" && value !== null) {
//         Object.assign(result, transformQueryParams(value, newKey));
//       } else {
//         result[newKey] = String(value);
//       }

//       return result;
//     },
//     {}
//   );
// }
